import { ReactNode } from 'react';
import styles from './AssetInfo.module.scss';

export interface AssetInfoRow {
  label: string;
  value?: ReactNode;
  displayCondition?: boolean;
  emphasis?: boolean;
}

interface AssetInfoProps {
  rows: AssetInfoRow[];
  verticalPadding?: boolean;
  horizontalPadding?: boolean;
}

export const AssetInfo = ({
  rows,
  verticalPadding = true,
  horizontalPadding = false,
}: AssetInfoProps) => {
  return (
    <div className={`${styles.content} ${verticalPadding && styles['content--verticalPadding']}`}>
      {rows.map(({ label, value, displayCondition = true, emphasis = false }) => {
        if (displayCondition) {
          return (
            <div
              key={label}
              className={`${styles.row} ${horizontalPadding && styles['row--horizontalPadding']}`}
            >
              <div className={styles.row__label}>{label}</div>
              <div
                className={`${styles.row__value} ${emphasis && styles['row__value--emphasis']} ${horizontalPadding && styles['row__value--horizontalPadding']}`}
              >
                {value}
              </div>
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};

export default AssetInfo;
